import { Spacer } from 'app/member/layouts/generic';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { setPageTitle } from 'store/actions/header';
import { DemosModule } from './demo';
import { PermissionsModule } from './permissions';
import { ResourcesModule } from './resources';
import { RolesModule } from './roles';
import { SavingsModule } from './savings';
import { StartupModule } from './startup';
import { UsersModule } from './users';
import { AgentsModule } from './agents';

const NAVITEMS = [
  {
    title: 'Users',
    path: '/user-management/users'
  },
  {
    title: 'Roles',
    path: '/user-management/roles'
  },
  {
    title: 'Resources',
    path: '/user-management/resources'
  },
  {
    title: 'Permissions',
    path: '/user-management/permissions'
  },
  {
    title: 'Demo Requests',
    path: '/user-management/demos'
  },
  {
    title: 'Savings Calc',
    path: '/user-management/savings'
  },
  {
    title: 'Startup Requests',
    path: '/user-management/startup'
  },
  {
    title: 'Agents',
    path: '/user-management/agents'
  }
];

export const UserManagementModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'User Management', path: '.' }]));
  }, []);

  return (
    <PageContentWrapper>
      <SlidingNav nav_items={NAVITEMS} />
      <Spacer multiple={4} />
      <Routes>
        <Route path="demos" element={<DemosModule />} />
        <Route path="savings" element={<SavingsModule />} />
        <Route path="startup" element={<StartupModule />} />
        <Route path="users" element={<UsersModule />} />
        <Route path="roles" element={<RolesModule />} />
        <Route path="resources" element={<ResourcesModule />} />
        <Route path="permissions" element={<PermissionsModule />} />
        <Route path="agents/*" element={<AgentsModule />} />
      </Routes>
    </PageContentWrapper>
  );
};
